import { useEffect } from 'react';

import { usePermissions } from 'src/common/hooks/usePermissions';
import { ProductType } from 'src/common/interfaces/Tenant';
import { useBreadcrumbStore } from 'src/common/stores/BreadcrumbStore';

import { getMobileSdkBreadcrumbRoutes } from '../helpers/MobileSdkDashboardHelpers';

export const useSetMobileSdkBreadcrumbs = (testId: string, testName: string): void => {
	const { updateBreadcrumbRoutes, setBreadcrumbRoutes } = useBreadcrumbStore();
	const isPlatformEnabledForMobileSdk = usePermissions(ProductType.MOBILE_SDK);

	useEffect(() => {
		const mobileSdkBreadcrumbRoutes = getMobileSdkBreadcrumbRoutes(testId, testName);
		updateBreadcrumbRoutes(isPlatformEnabledForMobileSdk ? mobileSdkBreadcrumbRoutes : []);

		return () => {
			setBreadcrumbRoutes([]);
		};
	}, [
		updateBreadcrumbRoutes,
		setBreadcrumbRoutes,
		testId,
		testName,
		isPlatformEnabledForMobileSdk
	]);
};
